import React from 'react'
import classnames from 'classnames'
import Grid from 'components/styled-components-grid'

import Input from 'components/input'
import ErrorText from 'components/ErrorText'
import FieldLabel from './FieldLabel'
import FieldErrorView from './FieldErrorView'

const TwoInputField = ({label, className, required, firstInput, secondInput, note, commonError}) => {
  const error = firstInput.error || secondInput.error
  return (
    <div className={classnames(className, {error: Boolean(error)})}>
      {label && <FieldLabel required={required}>{label}</FieldLabel>}

      <FieldErrorView error={error}>
        <Grid wrap={false}>
          <Grid.Unit size={firstInput.size || 2 / 7}>
            {!label && (
              <FieldLabel required={firstInput.required} error={firstInput.error}>
                {firstInput.label}
              </FieldLabel>
            )}
            <Input error={error} {...firstInput} />
            {firstInput.error && !commonError ? <ErrorText>{firstInput.error}</ErrorText> : note}
          </Grid.Unit>
          <Grid.Unit size={secondInput.size || 5 / 7} style={{marginLeft: '20px'}}>
            {!label && (
              <FieldLabel required={secondInput.required} error={secondInput.error}>
                {secondInput.label}
              </FieldLabel>
            )}
            <Input error={error} {...secondInput} />
            {secondInput.error && !commonError ? <ErrorText>{secondInput.error}</ErrorText> : note}
          </Grid.Unit>
        </Grid>
        {error && commonError ? <ErrorText>{error}</ErrorText> : note}
      </FieldErrorView>
    </div>
  )
}

export default TwoInputField
